import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';
import { BREAKPOINTS } from '../utilities/index';

(function () {
  'use strict';

  class CSlider {
    constructor(wrap) {
      this.wrap = wrap;
      //console.log(wrap);
      this.setThumb();
      this.setMain();
    }
    setThumb() {
      const thumb = this.wrap.querySelector('.c-slider__thumb');
      if (!thumb) return;
      this.thumb_swiper = new Swiper(thumb, {
        //loop: true,
        spaceBetween: 5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          [BREAKPOINTS.desktop]: {
            spaceBetween: 8,
          }
        }
      });
    }
    setMain() {
      const main = this.wrap.querySelector('.c-slider__main');
      if (!main) return;

      const next = main.querySelector('.swiper-button-next');
      const prev = main.querySelector('.swiper-button-prev');

      this.main_swiper = new Swiper(main, {
        modules: [Navigation, Thumbs],
        loop: true,
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: (next && prev) ? {
          nextEl: next,
          prevEl: prev,
        } : false,
        thumbs: {
          swiper: this.thumb_swiper || null,
        },
      });
    }
  }


  document.querySelectorAll('.c-slider').forEach((elm) => {
    new CSlider(elm);
  });

})();